import { useEffect } from 'react';
import { GIC_LIFECYCLE_EVENTS } from '@atlassian/jira-issue-create-extensibility/src/common/utils/lifecycle-events/constants.tsx';
import { useGICLifeCycleEvents } from '@atlassian/jira-issue-create-extensibility/src/common/utils/lifecycle-events/main.tsx';
import { useTriggerIssueCreateModal } from '@atlassian/jira-packages-controllers-use-trigger-issue-create-modal/src/main.tsx';

export const usePublishUseTriggerIssueCreateModalChange = () => {
	const [state] = useTriggerIssueCreateModal();
	const { publish } = useGICLifeCycleEvents();

	useEffect(
		() => publish(GIC_LIFECYCLE_EVENTS.USE_TRIGGER_ISSUE_CREATE_MODAL_STATE_CHANGE, state),
		[publish, state],
	);
};
